module.exports = __webpack_public_path__ + "static/media/lk.3ce70e50.svg";